export default {
  props: {
    userType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    };
  }
};
